/* ALÉNOR gift-wrap parent/child cart guard. Hotfix 2026-09-29. */
(() => {
  const GIFT_ID = '67384314036452';
  const ROOT = window.Shopify?.routes?.root || '/';
  const CART = `${ROOT}cart.js`;
  const ADD = `${ROOT}cart/add.js`;
  const CHANGE = `${ROOT}cart/change.js`;
  const CART_PAGE = (window.routes?.cart_url || `${ROOT}cart`).replace(/\/$/, '');
  let running = null;
  let checkoutPass = false;
  let timer = null;

  const isGift = (item) => String(item?.variant_id) === GIFT_ID;
  const props = (item) => item?.properties || {};
  const onCartPage = () => location.pathname.replace(/\/$/, '') === CART_PAGE;

  async function getCart() {
    const r = await fetch(CART, { headers: { Accept: 'application/json' }, cache: 'no-store' });
    if (!r.ok) throw new Error('Unable to read cart');
    return r.json();
  }

  async function changeLine(key, quantity) {
    const res = await fetch(CHANGE, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify({ id: key, quantity }),
    });
    const data = await res.json();
    if (!res.ok || data?.status) throw new Error(data?.description || data?.message || 'Unable to update cart');
    return data;
  }

  function lockGiftQuantity() {
    document.querySelectorAll('.cart-item').forEach((row) => {
      const link = row.querySelector('a[href*="/products/alenor-gift-wrap"]');
      if (row.dataset.alenorGiftLine !== 'true' && !link) return;
      row.querySelectorAll('quantity-input .quantity__button, .quantity__button').forEach((button) => {
        button.hidden = true;
        button.disabled = true;
      });
      row.querySelectorAll('.quantity__input, input[name="updates[]"]').forEach((input) => {
        input.readOnly = true;
        input.setAttribute('aria-readonly', 'true');
      });
    });
  }

  async function enforce({ reload = false } = {}) {
    if (running) return running;
    running = (async () => {
      let cart = await getCart();
      const parents = new Map();

      for (const item of cart.items || []) {
        if (isGift(item)) continue;
        const key = props(item)._alenor_gift_key;
        if (key) parents.set(String(key), Number(item.quantity) || 1);
      }

      const changes = [];
      for (const item of cart.items || []) {
        if (!isGift(item)) continue;
        const p = props(item);
        const parentKey = p._alenor_parent_key ? String(p._alenor_parent_key) : '';
        if (String(p._alenor_gift_wrap || '') !== '1' || !parentKey || !parents.has(parentKey)) {
          changes.push([item.key, 0]);
        } else if (Number(item.quantity) !== parents.get(parentKey)) {
          changes.push([item.key, parents.get(parentKey)]);
        }
      }

      for (const [key, qty] of changes) await changeLine(key, qty);

      if (changes.length) {
        cart = await getCart();
        if (reload && onCartPage()) {
          location.reload();
          return cart;
        }
      }

      lockGiftQuantity();
      return cart;
    })().finally(() => { running = null; });
    return running;
  }

  const pairKey = () => window.crypto?.randomUUID?.() || `alenor-${Date.now()}-${Math.random().toString(36).slice(2)}`;

  function lineProperties(fd) {
    const out = {};
    for (const [name, value] of fd.entries()) {
      const m = /^properties\[(.+)\]$/.exec(name);
      if (m && value !== '') out[m[1]] = value;
    }
    return out;
  }

  function productTitle(form) {
    const scope = form.closest('product-info, .product__info-container, .quick-add-modal__content-info') || document;
    const title =
      scope.querySelector('.product__title h1') ||
      scope.querySelector('h1.product__title') ||
      scope.querySelector('.product__title h2');
    return title?.textContent?.replace(/\s+/g, ' ').trim() || 'ALÉNOR product';
  }

  async function addWrapped(event, form, box) {
    event.preventDefault();
    event.stopImmediatePropagation();

    const myFour = Array.from(form.querySelectorAll('.alenor-my-four-fields select')).slice(0, 4);
    if (myFour.length) {
      const ids = myFour.map(select => select.options[select.selectedIndex]?.dataset.variantId || '');
      if (myFour.length !== 4 || ids.some(id => !id) || new Set(ids).size !== 4) {
        form.reportValidity();
        alert('Select four different fragrances for MY FOUR.');
        return;
      }
    }

    const fd = new FormData(form);
    const parentId = String(fd.get('id') || '');
    if (box.dataset.wrapScope === '50-ml' &&
        (parentId !== String(box.dataset.variantFifty || '') || box.dataset.availableFifty !== 'true')) {
      alert('Gift wrapping for 50 ML becomes available when the bottle is in stock.');
      return;
    }
    const giftId = String(box.dataset.giftVariant || '');
    const quantity = Math.max(1, parseInt(fd.get('quantity') || '1', 10) || 1);
    if (!parentId || !giftId) return;

    const token = pairKey();
    const parentProps = lineProperties(fd);
    parentProps._alenor_gift_key = token;

    const giftProps = {
      'Gift wrap for': productTitle(form),
      _alenor_gift_wrap: '1',
      _alenor_parent_key: token,
      _alenor_parent_variant_id: parentId,
    };

    const message = box.querySelector('textarea')?.value?.trim();
    if (message) giftProps['Gift message'] = message;

    const parent = { id: Number(parentId), quantity, properties: parentProps };
    const sellingPlan = fd.get('selling_plan');
    if (sellingPlan) parent.selling_plan = Number(sellingPlan);
    const gift = { id: Number(giftId), quantity, properties: giftProps };

    /* Shopify displays multi-added lines newest-first in the cart. Add gift first so the parent renders above it. */
    const body = { items: [gift, parent] };

    const submit = event.submitter || form.querySelector('[name="add"]');
    submit?.setAttribute('aria-disabled', 'true');
    submit?.classList.add('loading');

    try {
      const res = await fetch(ADD, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify(body),
      });
      const data = await res.json();
      if (!res.ok || data?.status) throw new Error(data?.description || data?.message || 'Gift wrap could not be added');

      /* Do not pass a multi-line add response to Craft's single-line cart renderer. It caused the null.innerHTML error. */
      location.href = CART_PAGE;
    } catch (e) {
      console.error('[ALÉNOR] Gift wrap add failed', e);
      alert(e.message || 'Gift wrap could not be added. Please try again.');
      submit?.removeAttribute('aria-disabled');
      submit?.classList.remove('loading');
    }
  }

  async function guardCheckout(event, submitter) {
    if (checkoutPass) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    submitter?.setAttribute('aria-disabled', 'true');
    try {
      const cart = await enforce();
      const hasParent = (cart.items || []).some((item) => !isGift(item));
      if (!hasParent) {
        location.href = CART_PAGE;
        return;
      }
      checkoutPass = true;
      submitter?.removeAttribute('aria-disabled');
      event.target.requestSubmit(submitter);
      checkoutPass = false;
    } catch (e) {
      checkoutPass = false;
      submitter?.removeAttribute('aria-disabled');
      console.error('[ALÉNOR] Checkout guard failed', e);
      alert('Please refresh your cart and try checkout again.');
    }
  }

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;

    const checked = form.querySelector('.alenor-gift-wrap__checkbox:checked');
    if (checked) {
      const box = checked.closest('.alenor-gift-wrap');
      if (box) return addWrapped(event, form, box);
    }

    const s = event.submitter;
    if (s && (s.name === 'checkout' || /checkout/i.test(s.id || ''))) guardCheckout(event, s);
  }, true);

  document.addEventListener('click', (event) => {
    const checkout = event.target.closest('a[href*="/checkout"]');
    if (checkout && !checkoutPass) {
      event.preventDefault();
      event.stopImmediatePropagation();
      enforce().then((cart) => {
        location.href = (cart.items || []).some((item) => !isGift(item)) ? checkout.href : CART_PAGE;
      }).catch(() => alert('Please refresh your cart and try checkout again.'));
      return;
    }

    if (event.target.closest('cart-remove-button, quantity-input .quantity__button, .cart-remove-button')) {
      clearTimeout(timer);
      timer = setTimeout(() => enforce({ reload: true }).catch(console.error), 150);
    }
  }, true);

  document.addEventListener('change', (event) => {
    if (!event.target.matches('.quantity__input, input[name="updates[]"]')) return;
    clearTimeout(timer);
    timer = setTimeout(() => enforce({ reload: true }).catch(console.error), 150);
  }, true);

  function init() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
        enforce({ reload: true }).catch(e => console.error('[ALÉNOR] Gift wrap synchronization failed', e));
      });
    }
    lockGiftQuantity();
    enforce({ reload: true }).catch((e) => console.error('[ALÉNOR] Gift wrap integrity check failed', e));
    new MutationObserver(lockGiftQuantity).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
